// Widgets
export const GET_WIDGETS_REQUEST = 'GET_WIDGETS_REQUEST';
export const GET_WIDGETS_SUCCESS = 'GET_WIDGETS_SUCCESS';
export const GET_WIDGETS_ERROR = 'GET_WIDGETS_ERROR';

export const UPDATE_WIDGET_REQUEST = 'UPDATE_WIDGET_REQUEST';
export const UPDATE_WIDGET_SUCCESS = 'UPDATE_WIDGET_SUCCESS';
export const UPDATE_WIDGET_ERROR = 'UPDATE_WIDGET_ERROR';

export const REORDER_WIDGETS_REQUEST = 'REORDER_WIDGETS_REQUEST';
export const REORDER_WIDGETS_SUCCESS = 'REORDER_WIDGETS_SUCCESS';
export const REORDER_WIDGETS_ERROR = 'REORDER_WIDGETS_ERROR';
